import { Controller } from "@hotwired/stimulus"
import IMask from "imask"

// Connects to data-controller="time-field"
export default class extends Controller {

  connect() {
    this.#initMask()
  }

  disconnect() {
    this.#destroyMask()
  }

  #initMask() {
    this.mask = IMask(this.element, {
      mask: "HH:mm",
      lazy: false,
      placeholderChar: '-',
      blocks: {
        HH: { mask: IMask.MaskedRange, from: 0, to: 23, maxLength: 2, },
        mm: { mask: IMask.MaskedRange, from: 0, to: 59, maxLength: 2, },
      },
    })

    this.mask.on('complete', () => {
      this.#dispatchCompleteEvent()
    })

    this.element.addEventListener('blur', this.#autoFillMinutes.bind(this))
  }

  #destroyMask() {
    if (this.mask) {
      this.mask.destroy()
      this.mask = null
    }
    this.element.removeEventListener('blur', this.#autoFillMinutes.bind(this))
  }

  #dispatchCompleteEvent() {
    this.dispatch("complete", { bubbles: true })
  }

  #autoFillMinutes() {
    const rawValue = this.mask.unmaskedValue
    if (rawValue.length > 0 && rawValue.length <= 2) {
      const hour = rawValue.padStart(2, '0')
      this.mask.value = `${hour}:00`
      this.#dispatchCompleteEvent()
    }
  }
}
